import React, { useRef } from "react";
import AppContainer from "../../../components/AppContainer";
import { Box, Stack } from "@mui/material";
import GlobalButton from "../../../components/CustomButton";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/AdminRole.json";
import AddEditRollDialog from "../../../components/Dialog/AddEditRollDialog";

const headerData = [
  "Name",
  "User Id",
  "Password",
  "Designation",
  "Assigned Pages",
  "Action",
];

const tableRows = [
  "role_name",
  "email",
  "password",
  "designation",
  "assigned_pages",
  "actions",
];

function AllSchoolRoles() {
  const openDialog = useRef();

  // Functions

  const handleEditRole = (row, ind) => {
    openDialog.current.isVisible({ type: "edit", data: row });
  };

  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"Create New Roles"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.isVisible({ type: "add", data: {} })
            }
          />
        </Box>
      </Stack>
    );
  };
  return (
    <>
      <AppContainer
        primaryHeading={"Create rolls"}
        secondaryHeading={
          "View, edit and delete your created roles management."
        }
        headProps={renderRightPart()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={TableData}
          showActions={true}
          showDelete={true}
          showEdit={true}
          handleDelete={(row) => console.log(row)}
          handleEdit={handleEditRole}
        />
      </AppContainer>
      <AddEditRollDialog ref={openDialog} />
    </>
  );
}

export default AllSchoolRoles;
